
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, } from "@fortawesome/free-solid-svg-icons";
import { Col, FormControl, FormGroup, FormLabel, Row, FormSelect, } from "react-bootstrap";

interface Data {
  id: any,
  formData: any;
  handleChange: any,
  handleBlur: any,
  errors: any
}

const PedidoInfo: React.FC<Data> = ({ id, formData, errors, handleBlur, handleChange }) => {

  return (
    <Row>
      <div className="d-flex align-items-center gap-2">
        <FontAwesomeIcon icon={faFile} className="fa-xl mb-2" />
        <h4>Informações do Pedido</h4>
      </div>
      {id ?
        <><Col className="col-lg-3 col-md-3 col-12">
          <FormGroup>
            <FormLabel>Código do Pedido</FormLabel>
            <FormControl type="text" id="codigo_pedido" value={formData?.codigo_pedido} disabled />
          </FormGroup>
        </Col></>
        : <></>
      }

      <Col className="col-lg-3 col-md-3 col-12">
        <FormGroup>
          <FormLabel>N° do Pedido (Rep.)</FormLabel>
          <FormControl
            type="text"
            id="nr_pedido"
            value={formData.nr_pedido}
            placeholder="N° do Pedido Rep."
            onBlur={handleBlur}
            onChange={handleChange}
            isInvalid={!!errors.nr_pedido}
            disabled={!!id}
          />
          <FormControl.Feedback type="invalid">{errors.nr_pedido}</FormControl.Feedback>
        </FormGroup>
      </Col>
      <Col className="col-lg-3 col-md-3 col-12">
        <FormGroup>
          <FormLabel>Ordem de Compra</FormLabel>
          <FormControl
            type="text"
            id="ordem_compra"
            value={formData.ordem_compra}
            placeholder="Ordem de Compra"
            onBlur={handleBlur}
            onChange={handleChange}
            isInvalid={!!errors.ordem_compra}
          />
          <FormControl.Feedback type="invalid">{errors.ordem_compra}</FormControl.Feedback>
        </FormGroup>
      </Col>
      <Col className="col-lg-3 col-md-3 col-12">
        <FormGroup>
          <FormLabel>Status do Pedido</FormLabel>
          <FormSelect
            id="status"
            value={formData.status}
            disabled
            onChange={handleChange}>
            <option value="0">Pedido Incompleto</option>
            <option value="1">Pedido Completo</option>
          </FormSelect>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default PedidoInfo;
